import { APP_MODAL_ID } from '../constants/app';

// Dialog content uses ID pattern: dialogId-content
const MODAL_CONTENT_ID = `${APP_MODAL_ID}-content`;

export const openAppModal = () => {
  (document.getElementById(MODAL_CONTENT_ID)! as HTMLDialogElement).showModal();
};

export const closeAppModal = () => {
  (document.getElementById(MODAL_CONTENT_ID)! as HTMLDialogElement).close();
};
